import { SyntheticEvent, useCallback } from 'react'

import { useDispatch } from 'react-redux'

import { foreignProfileOpenChatAction } from 'actions/foreignProfile/foreignProfileOpenChatAction'

export const useChatClickHandler = (profileId: number) => {
  const dispatch = useDispatch()

  const handleChatClick = useCallback(
    (event: SyntheticEvent) => {
      event.preventDefault()
      dispatch(foreignProfileOpenChatAction(profileId))
    },
    [dispatch, profileId]
  )

  return handleChatClick
}
